/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_About_HeadingInputs */

const en_apartment_about_heading = /** @type {(inputs: Apartment_About_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Space`)
};

/**
* | output |
* | --- |
* | "The Space" |
*
* @param {Apartment_About_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_about_heading = /** @type {((inputs?: Apartment_About_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_About_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_about_heading(inputs)
});